import React, { useRef, useState, useEffect, useCallback } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import ListingFilters from './ListingFilters.jsx';
import ListingContent from './ListingContent.jsx';

import "./css/Listing.css"

export default function Listing({ prevHist, prevPrice, prevMile, prevSearch, saveState }) {
  const [hist, setHist] = useState(prevHist);
  const [price, setPrice] = useState(prevPrice);
  const [mile, setMile] = useState(prevMile);
  const [searchTerm, setSearchTerm] = useState(prevSearch);
  const [filterOpen, setFilterOpen] = useState(false);
  const navigate = useNavigate();

  const updateHist = (id) => {
    if(hist === id) {
      setHist(0);
    } else {
      setHist(id);
    }
  };
  const updatePrice = (id) => {
    if(price === id) {
      setPrice(0);
    } else {
      setPrice(id);
    }
  };
  const updateMile = (id) => {
    if(mile === id) {
      setMile(0);
    } else {
      setMile(id);
    }
  };
  const updateSearchTerm = (term) => {
    setSearchTerm(term);
  };

  const goToReport = (link) => {
    saveState(hist, price, mile, searchTerm);
    navigate(link);
  }

  return (
    <div className="page">
      <ListingFilters isOpen={filterOpen} closeFilter={() => setFilterOpen(false)} updateHist={updateHist} hist={hist} updatePrice={updatePrice} price={price} updateMile={updateMile} mile={mile}/>
      <ListingContent hist={hist} price={price} mile={mile} searchTerm={searchTerm} updateSearchTerm={updateSearchTerm} goToReport={goToReport}/>
      <div className="filter-btn" onClick={() => setFilterOpen(true)}>
        <svg xmlns="http://www.w3.org/2000/svg" style={{display:"block"}} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
        </svg>
      </div>
    </div>
  );
}
